import common from "../../api/common";
import moment from "moment-timezone";

var timeReset = null;

const getDefaultState = () => {
  return {
    countries: [],
    senderIds: [],
    tagIds: [],
    replayIds: [],
    trackingCodes: [],
    senderLoaded: false,
    trackingLoaded: false,
    defaultPermRemind: "",
    currentTimezone: "",
    senderIdSpeed: 0,
    currentTime: moment().format("YYYY-MM-DD HH:mm:ss"),
    timezone: [],
    countryList: [],
    userCountry: "",
    taxCountryList: [],
    rewardShow: false,
    rewardLoader: false,
    rewardData: [
      // {
      //   logo: "appsumo",
      //   status: `Unreviewed`,
      // },
      {
        logo: "trustpilot",
        status: `Unreviewed`,
      },
      {
        logo: "g2",
        status: `Unreviewed`,
      },
      {
        logo: "capterra",
        status: `Unreviewed`,
      },
    ],
    pageLoad: "",
    userCountryDetails: {
      label: "",
      value: 0,
      countryCode: "",
      countryName: "",
    },
    registerEmailAddress: "",
    registerSource: "",
    fullStoryEnable: false,
    allowMultipleSender: false,
    allowAmpEmail: false,
    toasterMessage: "",
  };
};

const state = getDefaultState();

// getters
const getters = {
  getCountryList: (state) => {
    return state.countryList.map((item) => {
      return {
        value: item.countryId,
        label: item.name,
      };
    });
  },
  getCountryNameList: (state) => {
    return state.countryList.map((item) => {
      return {
        value: item.name,
        label: item.name,
      };
    });
  },
  getCountryNameCode: (state) => {
    return state.countryList.map((item) => {
      return {
        value: item.isoCode2,
        label: item.name,
      };
    });
  },

  getTimezone: (state) => {
    return state.timezone.map((item) => {
      return {
        value: item.gmt_zone,
        label: "(GMT" + item.gmt_adjust + ")" + item.gmt_zone,
        zone: item.gmt_zone,
      };
    });
  },
  getTaxCountryList: (state) => {
    // return state.taxCountryList
    return state.taxCountryList.map((item) => {
      return {
        value: item.taxType,
        label: item.taxName,
        format: item.format,
        countryName: item.country,
        countryCode: item.countryCode,
      };
    });
  },
};

const actions = {
  fetchCountries({ commit, state }) {
    if (!state.countries.length) {
      common.fetchCountries((data) => {
        commit("setCountries", data.data);
        if (data.userCountryDetails) {
          commit("setUserCountryDetails", data.userCountryDetails);
        }
      });
    }
  },

  reloadSenderIds({ commit, dispatch }, params) {
    commit("setSenderLoaded", false);
    return dispatch("fetchSenderIds", params);
  },

  resetTrackingCodes({ commit }) {
    commit("setTrackingLoaded", false);
  },

  fetchSenderIds({ commit, state }, params = { offset: 0, limit: 10 }) {
    if (!state.senderLoaded) {
      commit("setSenderLoaded", true);
      return new Promise(function (resolve) {
        common.fetchTags(params, (data) => {
          commit("setTagIds", data);
        });
        common.fetchSenderIds(params, (data) => {
          commit("setSenderIds", data);
          commit("setAllowMultipleSender", data);
          commit("setAllowAmpEmail", data);
          commit("setReplayIds", data);
          commit("setDefaultPermRemind", data);
          resolve(data.verified);
        });
      });
    }
  },

  fetchTrackingCodes({ commit, state }) {
    if (!state.trackingLoaded) {
      commit("setTrackingLoaded", true);
      common.fetchTrackingCodes((data) => {
        commit("setTrackingCodes", data);
      });
    }
  },

  convertHtmlToText(_, params) {
    if (!params.html) {
      return new Promise(function (resolve) {
        resolve({ data: "" });
      });
    }
    return common.convertHtmlToText(params);
  },

  getDragTemplate(_, { id }) {
    return common.getDragTemplate(id);
  },

  saveAsTemplate(_, data) {
    return common.saveAsTemplate(data);
  },
  fetchTimezone({ commit, state }) {
    if (!state.timezone.length) {
      common.fetchTimezone((data) => {
        commit("setTimezone", data);
      });
    }
  },
  fetchCurrentTime({ commit, state }, id) {
    common.fetchCurrentTime(id, ({ timezone, currentTime, senderIdSpeed }) => {
      commit("setCurrentTimezone", timezone);
      commit("setCurrentTime", currentTime);
      commit("setSenderIdSpeed", senderIdSpeed);
      if (timeReset) {
        clearInterval(timeReset);
      }
      timeReset = setInterval(() => {
        commit(
          "setCurrentTime",
          moment(state.currentTime)
            .add(1, "seconds")
            .format("YYYY-MM-DD HH:mm:ss")
        );
      }, 1000);
    });
  },
  fetchCountryList({ commit, state }) {
    if (!state.countryList.length) {
      common.fetchCountryList((data) => {
        commit("setCountryList", data.country_list);
        commit("setUserCountry", data.user_country);
      });
    }
  },
  fetchReward({ commit }) {
    commit("setRewardLoader", true);
    common.fetchReward((data) => {
      commit("setReward", data.ticket);
      commit("setRewardLoader", false);
    });
  },
  resetState({ commit }) {
    commit("resetState");
  },
  fetchTaxCountryList({ commit, state }) {
    if (!state.taxCountryList.length) {
      common.fetchTaxCountryList((data) => {
        commit("setTaxCountryList", data.data);
      });
    }
  },
};

const mutations = {
  setCountries(state, data) {
    state.countries = data;
  },
  setRegisterEmailAddress(state, data) {
    state.registerEmailAddress = data;
  },
  setRegisterSource(state, data) {
    state.registerSource = data;
  },
  setSenderIds(state, { senderIds }) {
    state.senderIds = senderIds;
  },
  setReplayIds(state, { replayIds }) {
    state.replayIds = replayIds;
  },
  setAllowMultipleSender(state, { allowMultipleSender }) {
    state.allowMultipleSender = allowMultipleSender;
  },
  setAllowAmpEmail(state, { allowAmpEmail }) {
    state.allowAmpEmail = allowAmpEmail;
  },
  setTagIds(state, { tagIds }) {
    state.tagIds = tagIds;
  },
  setTrackingCodes(state, { conversionTrackingCodes }) {
    state.trackingCodes = conversionTrackingCodes;
  },
  setTrackingLoaded(state, loaded) {
    state.trackingLoaded = loaded;
  },
  setSenderLoaded(state, loaded) {
    state.senderLoaded = loaded;
  },
  setDefaultPermRemind(state, { defaultPermRemind }) {
    state.defaultPermRemind = defaultPermRemind;
  },
  setCurrentTimezone(state, timezone) {
    state.currentTimezone = timezone;
  },
  setCurrentTime(state, currentTime) {
    state.currentTime = currentTime;
  },
  setSenderIdSpeed(state, senderIdSpeed) {
    state.senderIdSpeed = senderIdSpeed;
  },
  setTimezone(state, data) {
    state.timezone = data;
  },
  setCountryList(state, data) {
    state.countryList = data;
  },
  setReward(state, data) {
    state.rewardData = data;

    const index = state.rewardData.findIndex((fields) => {
      return fields.status === "Unreviewed";
    });
    if (index !== -1) {
      state.rewardShow = true;
    } else {
      state.rewardShow = false;
    }
  },
  setRewardLoader(state, data) {
    state.rewardLoader = data;
  },
  changeRewardStatus(state, data) {
    const index = state.rewardData.findIndex((fields) => {
      return fields.logo === data.brand;
    });
    if (index !== -1) {
      state.rewardData[index].status = data.status;
    }
  },
  setTaxCountryList(state, data) {
    state.taxCountryList = data;
  },
  setUserCountry(state, data) {
    state.userCountry = data;
  },
  setFullStoryEnable(state, data) {
    state.fullStoryEnable = data;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setPageLoad(state, flag) {
    state.pageLoad = flag;
  },
  setUserCountryDetails(state, data) {
    state.userCountryDetails = data;
  },
  setToasterMessage(state, message) {
    state.toasterMessage = message;
    setInterval(() => {
      state.toasterMessage = "";
    }, 100);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
